








































































































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class Navigation extends Vue {
  @Prop({ default: "" })
  readonly source!: string;

  dialog = false;

  drawer = null;

  readonly profileItems = [
    {
      icon: "exit_to_app",
      text: "Sign Out",
      action: (): void => this.signOut(),
    },
  ];

  readonly items = [
    { icon: "view_list", text: "Inventory", route: "inventory" },
    { icon: "archive", text: "Archive", route: "archive" },
    { divider: true },
    { icon: "settings", text: "Settings" },
    { icon: "chat_bubble", text: "Send feedback", route: "feedback" },
  ];

  goTo(route: string): void {
    if (this.$route.name !== route) this.$router.push({ name: route });
  }

  signOut(): void {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$router.push({ path: "/" });
      });
  }
}
